import {BrandType} from '@shared/cci/features/const/environment';

/**
 * @module whitelist.ts
 *
 * 이 파일의 역할은 잠깐 기능을 block하기 위해서 사용하는 임시 코드입니다.
 * 기능적으로 분리가 필요한 경우에는 inline에서 분기처리 해주셔야 합니다.
 *
 */

// brand 화이트리스트
export function checkExcludeBrand(brand1: BrandType, brand2?: BrandType, brand3?: BrandType): boolean {
  const excludeBrands = [brand1, brand2, brand3].filter(Boolean);
  const currentBrand = import.meta.env.VITE_BRAND as BrandType;

  return !excludeBrands.includes(currentBrand);
}

// environment 화이트리스트
export function checkIsNotProduction() {
  const currentEnv = import.meta.env.VITE_PROFILE as string;
  return currentEnv !== 'prod';
}
